export function isUserLoggedIn(loginInfo: {
    isLoggedIn: boolean,
    hasPrivateData: boolean,
    isSessionExpired: boolean
}) {
    const { isLoggedIn, hasPrivateData, isSessionExpired } = loginInfo;
    
    // User is logged in if:
    // - SIGTI API Token is present and not expired.
    // User is not logged in if:
    // - SIGTI API token is not present or expired.

    return {
        isLoggedIn: isLoggedIn && !isSessionExpired,
        hasEmsToken: hasPrivateData
    };
}